import React from "react";
import { Link } from "react-router-dom";

export default function ProgramDetailsSection({ data }) {
  if (!data) {
    return null;
  }

  return (
    <section className="program-details-section">
      <div className="container">
        <h2 className="heading text-center">{data.title}</h2>

        <div className="row program-details-section-cards">
          {data.items.map((program) => (
            <div className="col-lg-4" key={program.label}>
              <article className="program-detail-card">
                <img
                  className="program-detail-card-image"
                  src={program.image}
                  alt={program.imageAlt}
                />

                <div className="program-detail-card-content">
                  <p className="program-detail-card-label">{program.label}</p>
                  <h3>{program.title}</h3>
                  <p className="program-detail-card-description">
                    {program.description}
                  </p>

                  <div className="program-detail-card-included">
                    <div className="title">{data.includedTitle}</div>
                    <ul>
                      {program.included.map((item) => (
                        <li key={item}>
                          <i className="fa-solid fa-check" aria-hidden="true" />
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link className="default-btn" to={program.to}>
                    {program.button}
                  </Link>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
